<template>
  <div class="modal-cover" @click="onClose" v-if="!isLeaved">
    <div class="my-setting-container" @click.stop>
      <div class="my-setting-header-container">
        <button v-if="!isOpenModifyDataModal" class="close-modal" @click="onClose"></button>
        <button v-else-if="isOpenModifyDataModal" class="previous-modal" @click="onPreviousModal"></button>
        <div class="header-title">{{ getTitle }}</div>
        <button v-if="!isOpenModifyDataModal" class="save-btn" @click="onSubmit">{{ $t('common.save') }}</button>
        <button v-else-if="isOpenModifyDataModal && modifyDataType !== 'vacancyDetection'" class="save-btn" @click="onSaveTempData">{{ $t('common.save') }}</button>
        <button v-else-if="isOpenModifyDataModal && modifyDataType === 'vacancyDetection'" class="save-btn" @click="onSaveTempVacancy">{{ $t('common.save') }}</button>
      </div>
      <ul v-if="!isOpenModifyDataModal" class="my-setting-body-container">
        <li class="my-setting-item" @click="onOpenModifyDataModal('studyLevel')">
          <div class="setting-item-title flex items-center">{{ $t('camstudy.roomSetting.studyLevel') }}</div>
          <div class="setting-item-content flex items-center">
            <div v-if="showPremiumPlus" class="study-level" :class="{premiumPlus: true}">Premium+</div>
            <div v-if="showPremium" class="study-level" :class="{premium: true}">Premium</div>
            <div v-if="showFreePlus" class="study-level" :class="{freePlus: true}">Free</div>
            <img src="@/assets/images/camstudy/ico_arrowRight_gray.svg" class="w-8 h-8" />
          </div>
        </li>
        <li class="my-setting-item" @click="onOpenModifyDataModal('studyTitle')">
          <div class="setting-item-title flex items-center">{{ $t('camstudy.roomSetting.studyTitle') }}</div>
          <div class="setting-item-content flex items-center">
            {{ studyTitle }}
            <img src="@/assets/images/camstudy/ico_arrowRight_gray.svg" class="w-8 h-8" />
          </div>
        </li>
        <li class="my-setting-item with-desc">
          <div class="setting-item-title relative">
            <div class="flex">
              {{ $t('camstudy.roomSetting.openType.title') }}
              <div class="is-public-info-toggle" @click="onOpenPublicModal"></div>
            </div>
            <div v-if="isOpenPublicModal" class="popup-is-public z-50" v-click-outside="onClosePublicModal">
              <div class="close-modal absolute right-5 top-5" @click="onClosePublicModal"></div>
              <div class="public-info">
                <div class="public-info-title">{{ $t('camstudy.roomSetting.openType.public.title') }}</div>
                <div class="public-info-content">
                  {{ $t('camstudy.roomSetting.openType.public.desc1') }} <br />
                  {{ $t('camstudy.roomSetting.openType.public.desc2') }}
                </div>
              </div>
              <div class="public-info">
                <div class="public-info-title">{{ $t('camstudy.roomSetting.openType.private.title') }}</div>
                <div class="public-info-content">
                  {{ $t('camstudy.roomSetting.openType.private.desc1') }} <br />
                  {{ $t('camstudy.roomSetting.openType.private.desc2') }}
                </div>
              </div>
            </div>
            <pre class="content-description">{{ $t('camstudy.roomSetting.openType.desc') }}</pre>
          </div>
          <div class="setting-item-content is-public-container">
            <div class="is-public-content">{{ openType }}</div>
          </div>
        </li>
        <li class="my-setting-item with-desc" @click="onOpenModifyDataModal('definePasswd')">
          <div class="setting-item-title">
            {{ $t('camstudy.roomSetting.definePasswd') }}
          </div>
          <div class="setting-item-content flex items-center">
            {{ currentDefinePasswdInfo }}
            <img src="@/assets/images/camstudy/ico_arrowRight_gray.svg" class="w-8 h-8" />
          </div>
        </li>
        <li class="my-setting-item">
          <div class="setting-item-title flex items-center">{{ $t('camstudy.roomSetting.mainImage') }}</div>
          <div class="setting-item-content image" @click="onToggleRoomImageSetUpModal">
            <img :src="roomImage.url" :alt="$t('camstudy.roomSetting.mainImage')" />
          </div>
        </li>
        <li class="my-setting-item" @click="onOpenModifyDataModal('hashTagList')">
          <div class="setting-item-title flex items-center justify-center">{{ $t('camstudy.roomSetting.hashtag') }}</div>
          <div class="setting-item-content flex items-center">
            {{ currentHashTagInfo }}
            <img src="@/assets/images/camstudy/ico_arrowRight_gray.svg" class="w-8 h-8" />
          </div>
        </li>
        <li class="my-setting-item">
          <div class="setting-item-title flex items-center">{{ $t('camstudy.roomSetting.period') }}</div>
          <div class="setting-item-content">
            <div class="flex">
              <div class="date-container">
                <div class="date-input" >{{ formatStartDate }}</div>
              </div>
              <div class="ml-2 mr-2">~</div>
              <div class="date-container">
                <button class="date-input" @click="() => openDate('date2')">{{ formatEndResvDate }}<input type="date" ref="date2" :min="minDate" :max="maxDate" v-model="endResvDate"></button>
              </div>
            </div>
<!--            <div class="days-count">{{ $t('camstudy.roomSetting.totalDays', { days: totalStudyDate }) }}</div>-->
          </div>
        </li>
        <li class="my-setting-item">
          <div class="setting-item-title flex items-center">{{ $t('camstudy.roomSetting.targetStudy.time') }}</div>
          <div class="setting-item-content">
            <div class="flex gap-3 items-center">
              <div class="w-24 select-container">
                <GrmCamstudySelect
                    name="select-time"
                    :list="targetStudyTimeSetting"
                    :title="$t('camstudy.roomSetting.targetStudy.time')"
                    :value.sync="targetSelected"
                />
              </div>
              <div v-if="targetSelected && targetSelected !== 'none'" class="w-32 flex gap-3 items-center justify-between">
                <input class="time-input"
                       type="number"
                       max="24"
                       v-model="targetTime"
                       @input="filterNumberInput"
                />
                <div>
                  {{ $t('camstudy.roomSetting.targetStudy.hour') }}
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="my-setting-item with-desc">
          <div class="setting-item-title">
            {{ $t('camstudy.roomSetting.pointSystem') }}
            <div class="content-description">{{ $t('camstudy.roomSetting.pointSystemDescription') }}</div>
          </div>
          <div class="setting-item-content flex gap-6">
            <div class="flex gap-2">
              <GrmToggle :is-checked.sync="usePoint"/>
            </div>
<!--            <div class="flex items-center gap-2">-->
<!--              <input type="radio" name="reward" id="necessary" value="true" v-model="usePoint"/>-->
<!--              <label for="necessary">{{ $t('camstudy.roomSetting.necessary') }}</label>-->
<!--            </div>-->
<!--            <div class="flex items-center gap-2">-->
<!--              <input type="radio" name="reward" id="unnecessary" value="false" v-model="usePoint"/>-->
<!--              <label for="unnecessary">{{ $t('camstudy.roomSetting.unnecessary') }}</label>-->
<!--            </div>-->
          </div>
        </li>
        <li class="my-setting-item with-desc">
          <div class="setting-item-title">
            {{ $t('camstudy.roomSetting.initialDeviceSetting') }}
            <div class="content-description">{{ $t('camstudy.roomSetting.deviceSettingDescription') }}</div>
          </div>
          <div class="setting-item-content">
            <div class="flex gap-6">
              <div class="flex gap-2">
                <GrmToggle :is-checked.sync="checkDefaultCameraStatus"/>
              </div>
              <div class="flex gap-2" v-show="false">
                <GrmToggle :is-checked.sync="checkDefaultMicStatus"/>
              </div>
            </div>
          </div>
        </li>
        <li class="my-setting-item" @click="onOpenModifyDataModal('studyEtiqutte')">
          <div class="setting-item-title flex items-center">{{ $t('camstudy.roomSetting.studyEtiquette') }}</div>
          <div class="setting-item-content flex items-center">
            <div class="study-etiqutte-text">{{studyEtiqutte}}</div>
            <img src="@/assets/images/camstudy/ico_arrowRight_gray.svg" class="w-8 h-8" />
          </div>
        </li>
        <li class="my-setting-item with-desc" @click="onOpenModifyDataModal('vacancyDetection')">
          <div class="setting-item-title">
            {{ $t('camstudy.roomSetting.vacancyDetection.title') }}
            <div class="content-description">{{ $t('camstudy.roomSetting.vacancyDetection.desc') }}</div>
<!--            <GrmToggle :is-checked.sync="vacancyDetection" @onChange="changeStatus"/>-->
          </div>
          <div class="setting-item-content flex items-center">
            {{ (vacancyDetection || tempVacancyDetection) ? $t('camstudy.roomSetting.vacancyDetection.status.on') : $t('camstudy.roomSetting.vacancyDetection.status.off') }}
            <img src="@/assets/images/camstudy/ico_arrowRight_gray.svg" class="w-8 h-8" />
          </div>
        </li>
      </ul>
      <div v-if="isOpenModifyDataModal" class="my-setting-body-container">
        <input v-if="modifyDataType === 'studyTitle'" type="text" class="input-text" :placeholder="$t('camstudy.roomSetting.studyTitlePlaceholder')" v-model="tempInputData">
        <div v-else-if="modifyDataType === 'hashTagList'">
          <div class="hashtag-input-container">
            <input class="hashtag-input" type="text" v-model="tag" @keyup.enter.prevent="onEnterAddTag" :placeholder="$t('camstudy.roomSetting.hashtagPlaceholder')" maxLength="45" />
            <div class="add-button-container">
              <button class="add-button" @click="onEnterAddTag">{{$t('camstudy.invite.add')}}</button>
            </div>
          </div>
          <div class="hashtag-list">
            <div v-for="(tag, index) in tempInputData" :key="index" class="hashtag-item">
              {{ tag }}
              <button class="hashtag-delete" @click="removeTag(index)"></button>
            </div>
          </div>
        </div>
        <textarea v-else-if="modifyDataType === 'studyEtiqutte'" v-model="tempInputData" maxlength="1000" />
        <div v-else-if="modifyDataType === 'vacancyDetection'">
          <div class="vacancy-detection-image-container">
            <div class="vacancy-detection-image"></div>
            <div class="vacancy-title-container">
              <h4 class="vacancy-title">{{ $t('camstudy.roomSetting.vacancyDetection.title') }}</h4>
              <p class="vacancy-text">{{ $t('camstudy.roomSetting.vacancyDetection.desc') }}</p>
            </div>
          </div>
          <div class="my-setting-item">
            <div class="setting-item-title flex items-center">{{ $t('camstudy.roomSetting.vacancyDetection.title') }}</div>
            <div class="setting-item-content">
              <div class="flex gap-6">
                <div class="flex gap-2">
                  <GrmToggle :is-checked.sync="tempVacancyDetection" :disabled="!isVacancyDetectionEnabled" @onDisabled="onDisabled"/>
                </div>
              </div>
            </div>
          </div>
          <div class="my-setting-item">
            <div class="setting-item-title flex flex-col">
              {{ $t('camstudy.roomSetting.vacancyDetection.options.allowance.title') }}
              <pre class="content-description">{{ $t('camstudy.roomSetting.vacancyDetection.options.allowance.desc') }}</pre>
            </div>
            <div class="setting-item-content vacancy-input-container">
              <input max="60" type="number" class="vacancy-time-input" :disabled="!tempVacancyDetection" v-model="tempVacancyMinutes" @blur="onBlurVacancyTime" @input="filterVacancyTimerNumberInput" />
              <div class="vacancy-time-text">{{ $t('camstudy.roomSetting.vacancyDetection.options.allowance.unit') }}</div>
            </div>
          </div>
        </div>
        <div v-else-if="modifyDataType === 'studyLevel'">
          <div class="my-setting-item" @click="() => onClickStudyLevelRadio('premium-plus')">
            <div class="setting-item-title flex items-center">
              <div class="study-level" :class="{freePlus: false, premium: false, premiumPlus: true}">Premium+</div>
            </div>
            <div class="setting-item-content">
              <div class="flex gap-6">
                <div class="flex gap-2">
                  <input type="radio" name="study-level" ref="premium-plus" checked/>
                </div>
              </div>
            </div>
          </div>
          <div class="my-setting-item" @click="() => onClickStudyLevelRadio('premium')">
            <div class="setting-item-title flex items-center">
              <div class="study-level" :class="{not: true}">Premium</div>
            </div>
            <div class="setting-item-content">
              <div class="flex gap-6">
                <div class="flex gap-2">
                  <input type="radio" name="study-level" ref="premium" />
                </div>
              </div>
            </div>
          </div>
          <div class="my-setting-item" @click="() => onClickStudyLevelRadio('free-plus')">
            <div class="setting-item-title flex items-center">
              <div class="study-level" :class="{not: true}">Free</div>
            </div>
            <div class="setting-item-content">
              <div class="flex gap-6">
                <div class="flex gap-2">
                  <input type="radio" name="study-level" ref="free-plus" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="isFreeRoom" class="my-setting-item temp-btn-area">
            <button style="display: none;" class="free-v2-btn" @click="() => onClickStudyLevelRadio('free-v2')">{{ $t('camstudy.roomSetting.backToV2') }}</button>
          </div>
        </div>
        <div v-else-if="modifyDataType === 'definePasswd'">
          <div class="define-passwd-container">
            <input class="define-passwd-input" type="text" :placeholder="$t('camstudy.roomSetting.definePasswdPlaceholder')" maxLength="100" v-model="definePasswdValue" />
          </div>
        </div>
      </div>
    </div>
    <div @click.stop>
      <RoomImageSettingModal v-if="isOpenImageSettingModal"
                             @close="onToggleRoomImageSetUpModal"
                             @confirm="onChangeRoomImage"
      />
    </div>
  </div>
</template>

<script>
import {cdnImgUrl} from '@/utils/ImageUrl'
import {getCamStudyV2RootUrl} from '@/utils/CamStudyV2Helper'
import GrmToggle from "@/components/Common/toggle/GrmToggle.vue"
import {mapActions, mapGetters} from 'vuex'
import dayjs from 'dayjs'
import GrmCamstudySelect from "@/components/Common/camstudySelect/GrmCamstudySelect.vue";
import RoomImageSettingModal from '@/components/Room/Camstudy/control/RoomImageSettingModal.vue'

export default {
  name: "CamstudyRoomSettingModal",
  components: {
    RoomImageSettingModal,
    GrmCamstudySelect,
    GrmToggle,
  },
  data() {
    return {
      studyTitle: '',
      tag: '',
      isProcessingAddTag: false,
      addTagTimer: null,
      hashTagList: [],
      startDate: '',
      endResvDate: '',
      usePoint: false,
      definePasswdValue: '',
      defaultCameraStatus: true,
      defaultMicStatus: false,
      studyEtiqutte: '',
      targetTime: 0,
      roomImage: {
        file: null,
        path: null,
        modify: false,
        defaultImage: false
      },
      targetSelected: 'daily',
      isOpenImageSettingModal: false,
      isOpenPublicModal: false,
      tempInputData: '',
      isOpenModifyDataModal: false,
      modifyDataType: '',
      vacancyDetection: false,
      tempVacancyDetection: false,
      tempVacancyMinutes: 0,
      vacancyDetectMinutes: 0,
      selectedStudyLevel: 'premium-plus',
      currentRoomLevel: 'PREMIUM_PLUS',
      isVacancyDetectionEnabled: false,
    }
  },
  mounted() {
    this.studyTitle = this.getCamStudyInfo?.studyTitle
    this.hashTagList = [... this.getHashTagList]
    this.startDate = this.getCamStudyInfo?.startDate
    this.endResvDate = dayjs(this.getCamStudyInfo?.endResvDate).format('YYYY-MM-DD')
    this.usePoint = this.getCamStudyInfo?.usePoint
    this.defaultCameraStatus = this.room?.defaultCameraStatus === 'on'
    this.defaultMicStatus = this.room?.defaultMicStatus === 'on'
    this.studyEtiqutte = this.getCamStudyInfo?.studyContent
    this.targetSelected = this.getCamStudyInfo?.targetType || 'none'
    this.targetTime = this.getCamStudyInfo?.targetTime
    this.roomImage.url = cdnImgUrl(this.getRoomImagePath)
    this.vacancyDetection = this.getCamStudyInfo?.useVacancyDetection
    this.vacancyDetectMinutes = this.getCamStudyInfo?.vacancyDetectMinutes
    this.currentRoomLevel = this.room?.roomLevel || 'PREMIUM_PLUS'
    this.isVacancyDetectionEnabled = this.isUserTrialEnabledBy('AWAY_DETECTION')
    this.definePasswdValue = this.room?.passwd ? this.room.passwd : ''
  },
  computed: {
    ...mapGetters('room', [
      'room',
      'isLeaved',
    ]),
    ...mapGetters('user', [
        'hasEmceeRole'
    ]),
    ...mapGetters('camstudy', [
      'camStudy',
      'getHashTagList',
      'getRoomImagePath',
      'isUserTrialEnabledBy',
      'getUserPremiumLevel'
    ]),
    getCamStudyInfo() {
      return this.camStudy
    },
    getTitle() {
      if(!this.isOpenModifyDataModal){
        return this.$t('camstudy.roomSetting.title')
      }
      if(this.modifyDataType === 'studyTitle'){
        return this.$t('camstudy.roomSetting.studyTitle');
      }else if(this.modifyDataType === 'hashTagList'){
        return this.$t('camstudy.roomSetting.hashtag');
      }else if(this.modifyDataType === 'studyEtiqutte'){
        return this.$t('camstudy.roomSetting.studyEtiquette')
      }else if(this.modifyDataType === 'vacancyDetection'){
        return this.$t('camstudy.roomSetting.vacancyDetection.title')
      }
      return ''
    },
    minDate(){
      return dayjs(this.startDate).format('YYYY-MM-DD')
    },
    maxDate() {
      return dayjs(this.startDate).add(1, 'year').format('YYYY-MM-DD')
    },
    formatStartDate: {
      get() {
        return dayjs(this.startDate).format('YYYY.MM.DD')
      },
      set(date) {
        this.startDate = date
      }
    },
    formatEndResvDate: {
      get() {
        return dayjs(this.endResvDate).format('YYYY.MM.DD')
      },
      set(date) {
        this.endResvDate = date
      }
    },
    // totalStudyDate() {
    //   return DateFormatter.getDiffDate(this.startDate, this.endResvDate, 'days', true)
    // },
    checkDefaultCameraStatus: {
      get() {
        return this.defaultCameraStatus
      },
      set(status) {
        this.defaultCameraStatus = status
      }
    },
    checkDefaultMicStatus: {
      get() {
        return this.defaultMicStatus
      },
      set(status) {
        this.defaultMicStatus = status
      }
    },
    targetStudyTimeSetting() {
      return [
        {name: this.$t('camstudy.roomSetting.targetStudy.none'), value: 'none'},
        {name: this.$t('camstudy.roomSetting.targetStudy.daily'), value: 'daily'},
      ];
    },
    openType() {
      return this.room?.open
          ? this.$t('camstudy.roomSetting.openType.public.name')
          : this.$t('camstudy.roomSetting.openType.private.name')
    },
    currentHashTagInfo() {
      return this.hashTagList.length > 0
          ? this.$t('camstudy.roomSetting.currentHashTag.exist')
          : this.$t('camstudy.roomSetting.currentHashTag.empty')
    },
    showFreePlus() {
      return this.currentRoomLevel === 'FREE_PLUS';
    },
    showPremium() {
      return this.currentRoomLevel === 'PREMIUM';
    },
    showPremiumPlus() {
      return this.currentRoomLevel === 'PREMIUM_PLUS';
    },
    isFreeRoom() {
      return this.room?.roomLevel === 'FREE_PLUS';
    },
    currentDefinePasswdInfo() {
      return this.definePasswdValue?.length > 0
          ? this.$t('camstudy.roomSetting.currentDefinePasswd.exist')
          : this.$t('camstudy.roomSetting.currentDefinePasswd.empty')
    },
    useDefinePasswd: {
      get() {
        return this.definePasswdValue?.length > 0
      },
      set(value) {
        if (!value) {
          this.definePasswdValue = ''
        }
      }
    }
  },
  methods: {
    ...mapActions('camstudy', [
      'modifyCamStudyInfo',
      'uploadRoomImageFile',
      'modifyRoomImageUrl',
      'changeCamStudyType'
    ]),
    onEnterAddTag() {
      if (this.isProcessingAddTag) {
        return
      }
      this.isProcessingAddTag = true;
      this.addTag();

      if (this.addTagTimer) {
        clearTimeout(this.addTagTimer);
      }

      this.addTagTimer = setTimeout(() => {
        this.isProcessingAddTag = false;
      }, 700);
    },
    addTag() {
      if (this.tempInputData.length > 2) {
        this.isProcessingAddTag = true
        this.$camsAlert({
          text: this.$t('camstudy.roomSetting.hashtagLimitError'),
          ok: () => {
            this.isProcessingAddTag = false
          }
        });
        return
      }
      if (this.tag && this.tag.trim() !== '') {
        if (!this.tempInputData.includes(this.tag.trim())) {
          this.tempInputData.push(this.tag.trim());
        }
        this.tag = '';
      }
    },
    filterNumberInput(e) {
      const value = e.target.value
      if (value > 24) {
        e.target.value = 24
      } else if (value < 0) {
        e.target.value = 0
      }
      this.targetTime = Number(e.target.value)
    },
    filterVacancyTimerNumberInput(e){
      const value = e.target.value
      if (value > 60) {
        e.target.value = 60
      } else if (value < 0) {
        e.target.value = 0
      }
      this.tempVacancyMinutes = Number(e.target.value)
    },
    onClose() {
      this.$modal('CamstudyRoomSettingModal', {once: true})
    },
    onToggleRoomImageSetUpModal() {
      this.isOpenImageSettingModal = !this.isOpenImageSettingModal
    },
    async onSubmit() {
      if (!this.hasEmceeRole()) {
        this.$camsAlert(this.$t('camstudy.roomSetting.noRole'))
        return
      }

      if (!this.studyTitle) {
        this.$camsAlert(this.$t('camstudy.roomSetting.studyTitleError'))
        return
      }

      if (this.studyEtiqutte.length > 1000) {
        this.$camsAlert(this.$t('camstudy.roomSetting.studyEtiquetteMaxLength', {'0': 1000}))
        return
      }

      if (this.currentRoomLevel === 'FREE_PLUS' && this.room?.currJoinCnt > 4) {
        this.$camsAlert({
        title: this.$t('camstudy.roomSetting.freePlusRoomError.title'),
        text: this.$t('camstudy.roomSetting.freePlusRoomError.desc'),
        onlyOk: true,
      })
        return
      }

      const data = {
        studyTitle: this.studyTitle,
        hashtagList: this.hashTagList,
        endResvDate: dayjs(this.endResvDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        targetType: this.targetSelected === 'none' ? '' : this.targetSelected,
        targetTime: this.targetTime,
        usePoint: this.usePoint,
        defaultCameraStatus: this.defaultCameraStatus ? 'on' : 'off',
        defaultMicStatus: this.defaultMicStatus ? 'on' : 'off',
        studyContent: this.studyEtiqutte,
        useVacancyDetection: this.vacancyDetection,
        vacancyDetectMinutes: this.vacancyDetectMinutes,
        roomLevel: this.currentRoomLevel,
        useDefinePasswd: this.useDefinePasswd,
        passwd: this.definePasswdValue,
      }
      await this.modifyCamStudyInfo(data)

      if (this.roomImage.modify) {
        try {
          const defaultImage = this.roomImage.defaultImage
          let roomImagePath = this.roomImage.path
          if (!defaultImage) {
            roomImagePath = await this.uploadRoomImageFile(this.roomImage.file)
          }
          await this.modifyRoomImageUrl({roomImagePath, skipMoveImage: defaultImage})
        } catch (e) {
          console.error('## modify camstudyInfo error', e)
          this.$camsAlert(this.$t('camstudy.roomSetting.imageModifyError'))
        }
      }
      this.onClose()
    },
    openDate(value) {
      console.log(value, this.$refs)
      this.$refs[value]?.showPicker()
    },
    removeTag(index) {
      this.tempInputData.splice(index, 1);
    },
    onChangeRoomImage(data) {
      const { file, path, defaultImage } = data
      const newImage = {
        file,
        url: defaultImage ? cdnImgUrl(path) : path,
        path,
        modify: true,
        defaultImage: defaultImage
      }
      Object.assign(this.roomImage, newImage)
      this.isOpenImageSettingModal = !this.isOpenImageSettingModal
    },
    onOpenPublicModal(){
      this.isOpenPublicModal = true;
    },
    onClosePublicModal(){
      this.isOpenPublicModal = false;
    },
    onOpenModifyDataModal(title){
      this.isOpenModifyDataModal = true;
      this.modifyDataType = title;

      if(title === 'studyLevel') {
        this.selectedStudyLevel = this.currentRoomLevel.toLowerCase().replace('_', '-');

        this.$nextTick(() => {
          if(this.$refs[this.selectedStudyLevel]) {
            this.$refs[this.selectedStudyLevel].checked = true;
          }
          this.onClickStudyLevelRadio(this.selectedStudyLevel);
        });
        return;
      }

      if(Array.isArray(this[title])){
        this.tempInputData = [...this[title]]
        return;
      }
      this.tempVacancyDetection = this.vacancyDetection
      this.tempVacancyMinutes = this.vacancyDetectMinutes
      this.tempInputData = this[title];
    },
    onPreviousModal(){
      this.isOpenModifyDataModal = false;
      this.modifyDataType = '';
      this.tempInputData = '';
    },
    onSaveTempData(){
      this[this.modifyDataType] = this.tempInputData;
      this.isOpenModifyDataModal = false;
      this.tempInputData = '';
      this.modifyDataType = '';
    },
    onSaveTempVacancy(){
      this.vacancyDetection = this.tempVacancyDetection;
      this.vacancyDetectMinutes = this.tempVacancyMinutes;
      this.isOpenModifyDataModal = false;
      this.tempInputData = '';
      this.modifyDataType = '';
    },
    onBlurVacancyTime(){
      if(this.tempVacancyMinutes <= 0){
        this.tempVacancyMinutes = 1;
      }
    },
    onClickStudyLevelRadio(key){
      const userPremiumLevel = this.getUserPremiumLevel;
      const premiumLevel = userPremiumLevel.userPremiumLevel
      const isPremium = !!userPremiumLevel.premium
      const v2CamsHomeUrl = getCamStudyV2RootUrl()
      if (key === 'premium-plus') {
        if (!(isPremium && premiumLevel === 'PREMIUM_PLUS')) {
          this.$camsAlert({
            title: this.$t('camstudy.alert.notPremiumPlusUser'),
            text: this.$t('camstudy.alert.goToGooroomShop'),
            okText: this.$t('camstudy.alert.move'),
            ok: () => {
              location.href = v2CamsHomeUrl + '/camstudy/shop'
            }
          })
          return
        }
      }

      if (key === 'premium') {
        if (!(isPremium && (premiumLevel === 'PREMIUM' || premiumLevel === 'PREMIUM_PLUS'))) {
          this.$camsAlert({
            title: this.$t('camstudy.alert.notPremiumUser'),
            text: this.$t('camstudy.alert.goToGooroomShop'),
            okText: this.$t('camstudy.alert.move'),
            ok: () => {
              location.href = v2CamsHomeUrl + '/camstudy/shop'
            }
          })
          return
        }
      }

      if (key === 'free-v2') {
        this.$camsAlert({
          text: this.$t('camstudy.alert.backToV2'),
          ok: () => {
            this.changeCamStudyType({roomId: this.$room.roomId, roomLevel: 'FREE'})
                .catch((err) => {
                  this.$camsAlert({
                    text: this.$t('camstudy.alert.noPermission'),
                    onlyOk: true,
                  });
                });
          },
          cancel: () => {},
          onlyOk: false
        });

        return;
      }

      const premiumPlusDiv = this.$el.querySelector('.my-setting-item:nth-child(1) .study-level');
      const premiumDiv = this.$el.querySelector('.my-setting-item:nth-child(2) .study-level');
      const freePlusDiv = this.$el.querySelector('.my-setting-item:nth-child(3) .study-level');

      this.$refs['free-plus'].checked = false;
      this.$refs['premium'].checked = false;
      this.$refs['premium-plus'].checked = false;

      freePlusDiv.className = 'study-level not';
      premiumDiv.className = 'study-level not';
      premiumPlusDiv.className = 'study-level not';

      const levelMap = {
        'free-plus': {
          ref: 'free-plus',
          className: 'freePlus',
          level: 'FREE_PLUS'
        },
        'premium': {
          ref: 'premium',
          className: 'premium',
          level: 'PREMIUM'
        },
        'premium-plus': {
          ref: 'premium-plus',
          className: 'premiumPlus',
          level: 'PREMIUM_PLUS'
        }
      };

      const selected = levelMap[key];
      if (selected) {
        this.$refs[selected.ref].checked = true;
        this.$el.querySelector(`.my-setting-item:nth-child(${key === 'free-plus' ? 3 : key === 'premium' ? 2 : 1}) .study-level`).className = `study-level ${selected.className}`;
        this.currentRoomLevel = selected.level;
      }

      if (key === 'premium') {
        this.$camsAlert({
          text: this.$t('camstudy.alert.changeRoomType'),
          ok: () => {
            this.changeCamStudyType({roomId: this.$room.roomId, roomLevel: 'PREMIUM'})
                .catch((err) => {
                  this.$camsAlert({
                    text: this.$t('camstudy.alert.noPermission'),
                    onlyOk: true,
                  });
                  this.currentRoomLevel = 'PREMIUM_PLUS';
                  this.$refs['premium-plus'].checked = true;
                  premiumPlusDiv.className = 'study-level premiumPlus';
                });
          },
          cancel: () => {
            const roomLevel = this.room?.roomLevel;
            this.currentRoomLevel = roomLevel;
            this.$refs['premium-plus'].checked = roomLevel === 'PREMIUM_PLUS';
            this.$refs['premium'].checked = false;
            this.$refs['free-plus'].checked = roomLevel === 'FREE_PLUS';
            premiumPlusDiv.className = 'study-level ' + (roomLevel === 'PREMIUM_PLUS' ? 'premiumPlus' : 'not');
            premiumDiv.className = 'study-level not';
            freePlusDiv.className = 'study-level ' + (roomLevel === 'FREE_PLUS' ? 'freePlus' : 'not');
          },
          onlyOk: false
        });
      }
    },
    onDisabled(){
      this.$camsAlert({
        text: '해당 기능은 프리미엄 스터디에서만 사용하실 수 있습니다',
        onlyOk: true
      });
    }
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile] {
  .modal-cover {
    background-color: rgba(0, 0, 0, 0.5);
    @media(orientation: portrait) {
      left: 0;
      right: 0;
      bottom: 64px;
    }
    @media(orientation: landscape) {
      left: env(safe-area-inset-left);
      right: env(safe-area-inset-right);
      bottom: 98px;
      z-index: 99;
    }
    .my-setting-container{
      @media(orientation: portrait) {
        bottom: 0;
        left: 0;
        width: 100%;

        .my-setting-body-container {
          height: calc(100dvh - 107px);
        }
      }
      @media(orientation: landscape) {
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        .my-setting-body-container {
          height: calc(100% - 44px);
        }
      }
    }
  }
}
html:not([grm-device-mobile]) {
  .modal-cover {
    left: 0;
    right: 0;
    bottom: 80px;
    top: 0;
    .my-setting-container{
      bottom: -80px;
      top: 0;
      right: 0;
      width: 360px;
      border-left: 0.5px solid rgba(255, 255, 255, 0.20);
      background: #1A1A1A;

      .my-setting-body-container {
        height: calc(100% - 44px);
      }
    }
  }
}
.modal-cover{
  position: fixed;
  top: 0;
  line-height: 1.5;
  z-index: 100;
}
.my-setting-container{
  position: absolute;
  background: #1F1F1F;
  color: white;
  z-index: 100;

  .my-setting-header-container{
    display: flex;
    padding: 6px 16px;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    position: relative;

    .header-title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-weight: 500;
    }

    .save-btn {
      width: auto;
      padding: 7.5px 4px;
      color: #2A8BFE;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;
      line-height: 17px;
    }
  }
  .my-setting-body-container {
    position: relative;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none;
    }

    .my-setting-item + .my-setting-item{
      border-top: 0.333px solid rgba(255,255,255,0.06);
    }

    .my-setting-item{
      display: flex;
      padding: 12px 20px;
      justify-content: space-between;
      cursor: pointer;

      &.with-desc{
        padding-bottom: 20px;
      }

      .setting-item-title{
        flex-shrink: 0;
        font-size: 13px;
        height: 33px;
        line-height: 1.5;

        .is-public-info-toggle{
          width: 18px;
          height: 18px;
          padding: 1.5px;
          border-radius: 50%;
          background: url("~@/assets/images/camstudy/ico_wonder.svg") center center no-repeat;
          margin-left: 5.5px;
        }
        .popup-is-public{
          display: flex;
          flex-direction: column;
          gap: 12px;
          width: calc(100dvw - 40px);
          padding: 20px;
          position: absolute;
          left: 0;
          top: 100%;
          background: #313131;
          border-radius: 12px;

          .public-info{
            color: #FFF;
            .public-info-title{
              font-size: 14px;
              font-weight: 700;
              line-height: 150%;
            }
            .public-info-content{
              font-size: 12px;
              line-height: 150%;
            }
          }
        }
      }

      .setting-item-content{
        color: #999;
        font-size: 14px;

        &.image{
          position: relative;
          img{
            width: 72px;
            height: 48px;
            aspect-ratio: 3/2;
            border-radius: 6px;
          }
        }
        .select-container{
          border-radius: 6px;
          overflow: hidden;
          height: 33px;
        }
        .image-change-label{
          padding: 4px 8px;
          position: absolute;
          bottom: 0;
          left: 0;
          border-radius: 0 6px 0 0;
          background: rgba(0, 0, 0, 0.50);
          color: #FFF;
          font-size: 12px;
          display: flex;
          gap: 4px;
        }
        .image-input{
          opacity: 0;
          position: absolute;
        }
        input[type=radio]{
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          width: 33px;
          height: 33px;
          border-radius: 50%;
          outline: none;
          cursor: pointer;
          background: url('~@/assets/images/camstudy/ico_option_radio_not_checked.svg') no-repeat center;
        }
        input[type='radio']:checked {
          background: url('~@/assets/images/camstudy/ico_option_radio_checked.svg') no-repeat center;
        }
        .date-container{
          .date-input{
            display: inline-block;
            font-size: 14px;
            height: 33px;
            padding: 6px 12px;
            border-radius: 6px;
            background: #393939;
            position: relative;
            color: white;
          }
          input[type=date]{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0;
          }
        }
        .days-count{
          padding: 4px 8px;
          border-radius: 6px;
          background: #192F49;
          color: #FFF;
          font-size: 12px;
          font-weight: 700;
          display: inline-block;
          margin-top: 12px;
        }
        .device-setting-description{
          color: #999;
          font-size: 11px;
          margin-top: 8px;
        }
        //input[type=date]{
        //  height: 33px;
        //  padding: 6px 12px;
        //  border-radius: 6px;
        //  background: #393939;
        //  color: #FFF;
        //  font-size: 14px;
        //}
        & > img{
          aspect-ratio: 3 / 2;
          object-fit: cover;
        }
        &.is-public-container{
          display: flex;
          flex-direction: column;
          gap: 4px;
          .is-public-content{
            color: #999;
            font-size: 14px;
          }
        }
      }
      .content-description{
        color: #999;
        font-size: 11px;
      }

      &.temp-btn-area {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        border: none;

        .free-v2-btn {
          display: block;
          width: 100%;
          padding: 10px;
          border-radius: 6px;
          background-color: black;
          text-align: center;
          font-size: 12px;
          color: rgba(255,255,255,0.4);
        }
      }
    }
  }
  .close-modal{
    width: 32px;
    height: 32px;
    background: url("~@/assets/images/camstudy/ico_close_white.svg") center no-repeat;
    background-size: auto 24px;
  }
  .previous-modal{
    width: 32px;
    height: 32px;
    background: url("~@/assets/images/camstudy/ico_arrowLeft_white.svg") center no-repeat;
    background-size: auto 24px;
  }
  .my-setting-icon{
    width: 32px;
    height: 32px;
  }
}
.input-text, input[type=number]{
  appearance: none;
  -webkit-appearance: none;
  outline: transparent;
  display: block;
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid #393939;
  background: #141414;
  height: 33px;
  width: 100%;
  color: #808080;
  font-size: 14px;
  line-height: 150%;

  &.time-input{
    text-align: center;
    width: 80px;
    height: 33px;
    padding: 6px 12px;
    border-radius: 6px;
    background: #393939;
    border: none;
    color: white;
  }
}
.input-text{
  padding: 12px;
  line-height: 150%;
  width: calc(100% - 40px);
  margin: 0 auto;
}
.hashtag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 20px 0;
}

.hashtag-item {
  display: inline-flex;
  align-items: center;
  border-radius: 20px;
  background: #393939;
  color: #999;
  padding: 0 8px 0 12px;
  font-size: 14px;
  line-height: 32px;

  .hashtag-delete {
    width: 32px;
    height: 32px;
    cursor: pointer;
    background: url("~@/assets/images/camstudy/ico_close_gray.svg") no-repeat center;
  }
}
textarea{
  padding: 12px;
  width: calc(100% - 40px);
  margin-left: 20px;
  @media(orientation:portrait){
    aspect-ratio: 16 / 9;
  }
  @media(orientation:landscape){
    height: 200px;
  }
  border-radius: 8px;
  border: 1px solid #393939;
  background: #141414;
  color: #808080;
  font-size: 14px;
  line-height: 150%;
}
.study-etiqutte-text{
  max-width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  text-wrap: nowrap;
}
.hashtag-input-container{
  border-radius: 6px;
  margin: 0 auto;
  width: calc(100% - 40px);
  border: 1px solid #393939;
  background: #141414;
  display: flex;
  height: 45px;
  padding: 0 8px 0 12px;
  align-items: center;
  gap: 12px;

  .add-button-container{
    padding: 5px 4px;
    flex-shrink: 0;
    .add-button{
      border-radius: 6px;
      background: #016FF2;
      padding: 4px 8px;
      color: #FFF;
      font-size: 12px;
      font-weight: 700;
    }
  }
  .hashtag-input{
    height: 100%;
    width: 100%;
    border: none;
    outline: transparent;
    background: transparent;
    color: #808080;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
  }
}
.vacancy-detection-image-container{
  display: flex;
  height: 220px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 18px;
  .vacancy-detection-image{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: url('~@/assets/images/camstudy/vacancy_detection_image.svg') no-repeat;
  }
  .vacancy-title-container{
    text-align: center;
    .vacancy-title{
      color: #FFF;
      font-size: 14px;
      margin-bottom: 8px;
    }
    .vacancy-text{
      color: #999;
      font-size: 11px;
    }
  }
}
.vacancy-input-container{
  display: flex;
  .vacancy-time-input{
    width: 50px;
    padding: 6px 12px;
    border-radius: 6px;
    border: 1px solid #393939;
    background: #141414;

    color: #FFF;
    &:disabled{
      color: #999;
    }
  }
  .vacancy-time-text{
    color: white;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 14px;
  }
}
.study-level{
  padding: 9px 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  border-radius: 6px;
  width: 100px;

  &.freePlus{
    background: #000000;
  }
  &.premium{
    background: #AF24B3;
  }
  &.premiumPlus{
    background: linear-gradient(90deg, #0069FF 0.01%, #0560E3 0.44%, #4299FF 100%);
  }
  &.not{
    background: #393939;
    color: #999999;
  }
}
.define-passwd-container{
  border-radius: 6px;
  margin: 0 auto;
  width: calc(100% - 40px);
  border: 1px solid #393939;
  background: #141414;
  display: flex;
  height: 45px;
  padding: 0 8px 0 12px;
  align-items: center;
  gap: 12px;

  .define-passwd-input{
    height: 100%;
    width: 100%;
    border: none;
    outline: transparent;
    background: transparent;
    color: #808080;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
  }
}
</style>